import { useZodForm } from '../../../hooks/useZodForm.ts';
import { schSubjectPropertyDetailsForm } from '../schemas.ts';

export const useSubjectPropertyDetailsForm = () =>
  useZodForm({
    schema: schSubjectPropertyDetailsForm,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {},
    shouldFocusError: false, // Prevent focus jumping on validation errors
  });
